import React from 'react';
import {View, StyleSheet} from 'react-native';
import {Colors} from '../index';
import {ComponentProps} from './ComponentProps';

interface DividerProps extends ComponentProps {}

export const DividerS = (props: DividerProps) => {
  return <Divider {...{...props, marginVertical: 15}} />;
};

export const DividerM = (props: DividerProps) => {
  return <Divider {...{...props, marginVertical: 30}} />;
};

interface DividerComponentProps extends DividerProps {
  marginVertical?: number;
}

export const Divider = (props: DividerComponentProps) => {
  return (
    <View style={props.containerStyle}>
      <View style={[styles.container, {marginVertical: props.marginVertical ?? 0}]} testID={props.testID} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {height: 1, backgroundColor: Colors.neutralLightAlpha},
});
